/** Stable URL/API values for contact form topic (locale-agnostic). */

export const CONTACT_SUBJECT_KEYS = [
  "general",
  "ads",
  "cooperation",
  "complaint",
  "support",
  "other",
] as const;

export type ContactSubjectKey = (typeof CONTACT_SUBJECT_KEYS)[number];

/** Legacy ?subject= values in Russian from older links. */
const LEGACY_RU_LABEL_TO_KEY: Record<string, ContactSubjectKey> = {
  "Общий вопрос": "general",
  Реклама: "ads",
  Сотрудничество: "cooperation",
  Жалоба: "complaint",
  Техподдержка: "support",
  Другое: "other",
};

export function normalizeContactSubjectParam(raw: string | undefined): ContactSubjectKey | "" {
  if (!raw?.trim()) return "";
  const v = raw.trim();
  if ((CONTACT_SUBJECT_KEYS as readonly string[]).includes(v)) {
    return v as ContactSubjectKey;
  }
  return LEGACY_RU_LABEL_TO_KEY[v] ?? "";
}
